import React, { useContext, useState, useEffect } from "react";
import LoadingAction from "../../../../themes/LoadingAction/LoadingAction";
import { Button, Input, DatePicker, Tooltip } from "antd";
import { AuthContext } from "../../../../contexts/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import { FaArrowLeft } from 'react-icons/fa';
import axios from "axios";
import question_icon from "../../../../assets/images/question.png";
import moment from "moment";

const EditCliente = (props) => {

  const styles = `
  .Maquinas-page {
    background-color: black;
    color: white; 
    margin: 0; 
    padding: 0; 
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    flex-direction: column;
    height: 100vh;
    height: 100dvh;
    min-height: 100vh;
    min-height: 100dvh;
    width: 100vw;
    overflow: auto;     
  }
    
.Edit_header {
  display: flex;
  align-items: flex-start; 
  justify-content: flex-start; 
  margin: 10px 20px 20px 20px;
  padding: 0;
  gap: 20px;
}
  .Edit_header_title {
  background-color: transparent !important;
  color: rgb(250, 247, 83) !important;
  border-radius: 5px !important;
  display: flex; 
  align-items: center; 
  justify-content: center;
  text-align: center;
  height: auto; 
  font-size: 30px;
  margin-top: 50px;
  }
  .Botao-Voltar {
  display: inline-flex;
  font-size: 20px;
  font-weight: bold;
  padding: 20px; 
  align-items: center; 
  justify-content: flex-start !important;
  text-align: center;
  border-radius: 10px;
  border: none;
  background-color: rgb(163, 3, 163);
  color: white;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 50px;
  border: 1px solid #ffffff;
  }
  .Botao-Voltar:hover {
  background-color: rgb(250, 31, 250);
  }
  .Edit_content {
    align-items: flex-start; 
    display: flex;
    flex-direction: column;
    max-width: 400px;
    padding: 30px;
  }
  .Edit_itemField {
    padding: 10px 0px;
    width: 100%;
  }
  .Edit_itemField input {
    border: 1px solid #55b962;
    border-radius: 4px;
    background-color: rgb(248, 249, 250);
  }
  .Edit_itemField input .Edit_inputError {
    border: 1px solid #e46772;
  }
  .Edit_itemFieldError {
    color: #e46772;
    font-size: 14px;
    padding: 2px 0;
  }
  .Edit_storeLabel {
    display: flex;
  }
  .Edit_Icon {
    width: 23px;
    height: 23px;
    margin-left: 7px;
  }
  .Edit_container {
    padding: 20px;
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    height: 100%;
  }
  .Edit_editBtn {
    display: flex !important;
    align-items: center;
  }
  .Edit_editBtn span {
    margin-left: 5px;
  }
  .Edit_back {
    font-weight: 400;
    font-size: 18px;
    line-height: 27px;
    text-decoration: underline;
    color:rgb(118, 120, 122);
  }
  .Edit_staBlockTitle {
    font-weight: 400;
    font-size: 24px;
    line-height: 27px;
    padding: 10px 15px;
  }
  .Edit_Icon {
    cursor: pointer;
    width: 22px;
    margin-left: 10px;
    margin-bottom: 0.5rem;
  }
  .EditLabel_Icon {
    display: flex;
    align-items: center;
  }
  .custom-datepicker input::placeholder {
    color: black !important;
    opacity: 1; 
  }
  .Botao-Salvar {
    margin-top: 20px;
    background-color:rgb(6, 128, 2);
    color: #fff;
    border-radius: 4px;
    width: 100%;
    border: 1px solid #ffffff;
    display: flex; 
    align-items: center; 
    justify-content: center; 
    text-align: center;
    font-size: 20px;
    font-weight: bold;
  }
  .Botao-Salvar:hover {
    background-color:rgb(78, 247, 100);
    color: #fff;
  }
  .Botao-Excluir {
    margin-top: 20px;
    background-color:rgb(247, 31, 2);
    color: #fff;
    border-radius: 4px;
    width: 100%;
    border: 1px solid #ffffff;
    display: flex; 
    align-items: center; 
    justify-content: center; 
    text-align: center;
    font-size: 20px;
    font-weight: bold;
  }
  .Botao-Excluir:hover {
    background-color:rgb(250, 77, 54);
    color: #fff;
  }  
  .Edit_itemField .ant-picker {
    width: 100%;
  }

  @media only screen and (max-width: 760px) and (orientation: portrait) {
   .Edit_header {
    display: flex;
    flex-direction: column; 
    align-items: center; 
    width: 100%; 
    gap: 10px;
    margin: 0;
    padding: 20px;
    align-items: center !important;
    justify-content: flex-start !important;
   }
   .Edit_header_title {
    width: 100%; 
    text-align: center !important; 
    font-size: 28px; 
    margin: 0; 
    padding-bottom: 15px;
   }
   .Botao-Voltar {
    margin: 0; 
    font-size: 22px;
    text-align: center;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    display: inline-flex;
    width: auto !important; 
    max-width: fit-content !important; 
    white-space: nowrap; 
  }


  `;

    useEffect(() => {
      const styleSheet = document.createElement("style");
      styleSheet.type = "text/css";
      styleSheet.innerText = styles;
      document.head.appendChild(styleSheet);
  
      return () => {
        document.head.removeChild(styleSheet);
      };
    }, [styles]);

  const location = useLocation();
  let navigate = useNavigate();

  const { authInfo, setNotiMessage } = useContext(AuthContext);

  const token = authInfo?.dataUser?.token;

  const { id } = location.state || {};
  // console.log("ID do cliente recebido:", id);

  const [data, setData] = useState({}); // Estado inicial para os dados
  const [errors, setErrors] = useState({}); // Estado inicial para erros

  const [isLoading, setIsLoading] = useState(false);

  const [cliente, setCliente] = useState({
    nome: '',
    email: '',
    senha: '',
    mercadoPagoToken: '',
    novaId: '',
    mensalidade: '',
    telefone: '',
    pessoaId: '',
    dataInclusao: '',
    ultimoAcesso: '',
    ativo: true,
    dataVencimento: ''
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_SERVIDOR}/clientes-info/${id}`,
          {
            method: "GET",
            headers: {
              "x-access-token": token,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error(`Erro na requisição: ${response.statusText}`);
        }
        const clienteData = await response.json();

        if (clienteData.dataVencimento) {
          clienteData.dataVencimento = moment.utc(clienteData.dataVencimento).format("YYYY-MM-DD");
          // console.log("Data de Vencimento Convertida UTC:", clienteData.dataVencimento);
        }
        setCliente(clienteData);
        setData(clienteData);

      } catch (err) {
        console.error("Erro na busca do cliente:", err.message);
        setErrors(err.message);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [id, token]);

  const handleChange = (name, value) => {
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => {
      let errorsTemp = { ...prev };
      delete errorsTemp[name];
      return errorsTemp;
    });
  };

  const onSave = () => {// check require

    let errorsTemp = {};

    if (data.nome.trim() === "") {
      errorsTemp.nome = "Este campo é obrigatório";
    }


    if (data.telefone.trim().length < 12) {
      errorsTemp.telefone = "Precisa ter codigo do país e codigo de área";
    }

    if (Object.keys(errorsTemp).length > 0) {
      setErrors(errorsTemp);
      return;
    }

    const adjustedDateVencimento = moment(data.dataVencimento).startOf('day').utc().toDate();

    let body = {
      nome: data.nome,
      dataVencimento: adjustedDateVencimento,
      email: data.email,
      senha: data.senha,
      mensalidade: data.mensalidade,
      telefone: data.telefone,
      novaId: data.novaId,
    };

    if (
      data.mercadoPagoToken &&
      data.mercadoPagoToken.toString() !== cliente.mercadoPagoToken.toString()
    )
      body.mercadoPagoToken = data.mercadoPagoToken;

    setIsLoading(true);
    axios
      .put(
        `${process.env.REACT_APP_SERVIDOR}/alterar-cliente-adm-new/${cliente.id}`,
        body,
        {
          headers: {
            "x-access-token": token,
            "content-type": "application/json",
          },
        }
      )
      .then((res) => {
        setIsLoading(false);
        navigate(`/dashboard-clientes`, {
          state: location.state,
        });
      })
      .catch((err) => {
        setIsLoading(false);
        if ([401, 403].includes(err.response.status)) {
          setNotiMessage({
            type: "error",
            message:
              "Sua sessão expirou, faça login novamente. 07",
          });
        } else if (err.response.status === 400) {
          setNotiMessage({
            type: "error",
            message: "Nome do cliente, email ou ID já existe",
          });
          setErrors((prev) => ({
            ...prev,
            nome: "Nome do cliente, email ou ID já existe",
          }));
        } else {
          setNotiMessage({
            type: "error",
            message: "Um erro ocorreu",
          });
        }
      });
  };

  return (
    <div className="Maquinas-page">
      {isLoading && <LoadingAction />}
      <div className="Edit_header">
        <div className="Edit_header_title">EDITAR CLIENTE</div>
        <Button
          className="Botao-Voltar"
          onClick={() => {
            navigate(`/cliente-maquinas/${id}`, {
              state: location.state,
            });
          }}
        >
          <FaArrowLeft />
          <span>VOLTAR</span>
        </Button>
      </div>

      <div className="Edit_content">

        <div className="Edit_itemField">
          <label className="Edit_itemFieldLabel" htmlFor="novaId">
            Alterar ID do cliente:
          </label>
          <Input
            value={data.novaId || cliente.id}
            id="novaId"
            type="text"
            name="novaId"
            autoComplete="novaId"
            onChange={(event) => {
              handleChange("novaId", event.target.value);
            }}
            className={`${!!errors.novaId ? "Edit_inputError" : ""}`}
          />
          {errors.nome && (
            <div className="Edit_itemFieldError">{errors.novaId}</div>
          )}
        </div>

        <div className="Edit_itemField">
          <div className="Edit_Label_Icon">
            <label
              className="Edit_itemFieldLabel"
              htmlFor="mercadoPagoToken"
            >
              Alterar token:
            </label>
          </div>
          <Input
            value={data.mercadoPagoToken}
            id="mercadoPagoToken"
            type="text"
            name="mercadoPagoToken"
            autoComplete="mercadoPagoToken"
            onChange={(event) => {
              handleChange("mercadoPagoToken", event.target.value);
            }}
            className={`${!!errors.mercadoPagoToken ? "Edit_inputError" : ""
              }`}
          />
          {errors.mercadoPagoToken && (
            <div className="Edit_itemFieldError">
              {errors.mercadoPagoToken}
            </div>
          )}
        </div>

        <div className="Edit_itemField">
          <label className="Edit_itemFieldLabel" htmlFor="nome">
            Alterar nome:
          </label>
          <Input
            value={data.nome}
            id="nome"
            type="text"
            name="nome"
            autoComplete="nome"
            onChange={(event) => {
              handleChange("nome", event.target.value);
            }}
            className={`${!!errors.nome ? "Edit_inputError" : ""}`}
          />
          {errors.nome && (
            <div className="Edit_itemFieldError">{errors.nome}</div>
          )}
        </div>

        <div className="Edit_itemField">
          <label className="Edit_itemFieldLabel" htmlFor="email">
            Alterar email:
          </label>
          <Input
            value={data.email}
            id="email"
            type="text"
            name="email"
            autoComplete="email"
            onChange={(event) => {
              handleChange("email", event.target.value);
            }}
            className={`${!!errors.email ? "Edit_inputError" : ""}`}
          />
          {errors.nome && (
            <div className="Edit_itemFieldError">{errors.email}</div>
          )}
        </div>

        <div className="Edit_itemField">
          <label className="Edit_itemFieldLabel" htmlFor="senha">
            Alterar senha:
          </label>
          <Input
            value={data.senha}
            id="senha"
            type="text"
            name="senha"
            autoComplete="senha"
            onChange={(event) => {
              handleChange("senha", event.target.value);
            }}
            className={`${!!errors.senha ? "Edit_inputError" : ""}`}
          />
          {errors.nome && (
            <div className="Edit_itemFieldError">{errors.senha}</div>
          )}
        </div>

        <div className="Edi_itemField">
          <label className="Edit_itemFieldLabel" htmlFor="telefone">
            Telefone para mensagens:
          </label>
          <Input
            value={data.telefone}
            id="telefone"
            type="number"
            name="telefone"
            autoComplete="telefone"
            onChange={(event) => {
              handleChange("telefone", event.target.value);
            }}
            className={`${!!errors.telefone ? "Edit_inputError" : ""
              }`}
          />
          {errors.telefone && (
            <div className="Edit_itemFieldError">
              {errors.telefone}
            </div>
          )}
        </div>

        <div className="Edit_itemField">
          <label className="Edit_itemFieldLabel" htmlFor="mensalidade">
            Valor da mensalidade:
          </label>
          <Input
            value={data.mensalidade}
            id="mensalidade"
            type="number"
            name="mensalidade"
            autoComplete="mensalidade"
            onChange={(event) => {
              handleChange("mensalidade", event.target.value);
            }}
            className={`${!!errors.mensalidade ? "Edit_inputError" : ""
              }`}
          />
          {errors.mensalidade && (
            <div className="Edit_itemFieldError">
              {errors.mensalidade}
            </div>
          )}
        </div>

        <div className="Edit_itemField">
          <div className="Edit_label_Icon">
            <label
              className="Edit_itemFieldLabel" htmlFor="mercadoPagoToken"
            >
              Vencimento da mensalidade:
            </label>
            <Tooltip title="A data de vencimento do cliente é uma data que após 10 dias é feito a trava das máquinas do cliente para receber pagamentos. Ideal para quem cobra mensalidade, se não definida por padrão colocamos 1 (um) ano. se não quiser usar coloque uma data maior">
              <img
                src={question_icon}
                alt="question icon"
                className="Edit_Icon"
              />
            </Tooltip>
          </div>
          <DatePicker
            placeholder={data.dataVencimento}
            style={{ color: "black" }}
            className={`custom-datepicker ${!!errors.dataVencimento ? "Edit_inputError" : ""
              }`}
            defaultValue={data.dataVencimento}
            format={"YYYY-MM-DD"}
            id="dataVencimento"
            name="dataVencimento"
            autoComplete="dataVencimento"
            onChange={(vl, dateString) => {
              handleChange("dataVencimento", dateString);
            }}
          />
          {errors.dataVencimento && (
            <div className="Edit_itemFieldError">
              {errors.dataVencimento}
            </div>
          )}

        </div>
        <Button
          className="Botao-Salvar"
          onMouseEnter={(e) => (e.target.style.color = "#fff")}
          onMouseLeave={(e) => (e.target.style.color = "#fff")}
          onClick={() => {
            if (!isLoading) onSave();
          }}
          disabled={isLoading}
        >
          SALVAR ALTERAÇÕES
        </Button>
        <Button
          className="Botao-Excluir"
          onMouseEnter={(e) => (e.target.style.color = "#fff")}
          onMouseLeave={(e) => (e.target.style.color = "#fff")}
          onClick={() => {
            navigate(`/delete-cliente/${id}`, {
              state: location.state,
            });
          }}
          disabled={isLoading}
        >
          EXCLUIR CLIENTE
        </Button>
      </div>
    </div>
  );
};

export default EditCliente;
